
export default {
  props: {
    popperClass: {
      type: String,
      default: ''
    },
    showPopover: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '44rem'
    },
    height: {
      type: String,
      default: 'max-content'
    },
    rows: {
      type: [String, Number],
      default: '4'
    },
    minLength: {
      type: Number,
      default: undefined
    },
    divider: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'top'
    },
    fbId: {
      type: String,
      default: undefined
    },
    teleported: {
      type: Boolean,
      default: false
    }
  },
  emits: ['send','show'],
  data() {
    return {
      fb_id: this.fbId || crypto.randomUUID(),
      visible: false,
      message: '',
    }
  },
  computed: {
    c_popper_class() {
      return `feedback-popover ${this.popperClass}`.trim()
    },
    can_send() {
      if (this.minLength === undefined) return true
      return this.message.length > this.minLength
    },
    c_width() {
      if (this.$responsive.desktop) return this.width
      else if (this.$responsive.mobile) return '90%'
      return '27.2rem'
    },
    c_teleported() {
      if (!this.$responsive.desktop) return true
      return this.teleported
    }
  },
  watch: {
    visible(){
      if (!this.visible) this.message = ''
    }
  },
  methods: {
    async onSend(){
      const message = this.message.trim() || undefined
      this.visible = false
      this.$emit('send', message)
    },
    onShow(){
      if (this.showPopover) {
        this.$emit('show', {id: this.fb_id, show: true})
        this.visible = true
      }
      else this.$emit('send')
    },
    onHide(){
      this.$emit('show', {id: this.fb_id, show: false})
    },
    onClose() {
      this.visible = false
    }
  }
}
